import { createFileRoute } from '@tanstack/react-router';

import { bankAccountDetailSearch, loadBankAccountMessages, loadBankAccountScreens, transitoryAccountScreen } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Conta transitória somente leitura (`router.tsx:487-519`), aberta pela aba Conta bancária da operação.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/visualizar/')({
  validateSearch: bankAccountDetailSearch,
  staticData: { screen: transitoryAccountScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'TransitoryAccountScreen'),
});
